import { FC } from "react";
import Sort from "../../UI/Icons/Sort";
import {
  ReferralSortField,
  SortOrder,
} from "../../../store/superadmin/referral/types";

interface ReferralTableHeaderProps {
  sortBy: ReferralSortField;
  sortOrder: SortOrder;
  onSortChange: (field: ReferralSortField) => void;
}

const ReferralTableHeader: FC<ReferralTableHeaderProps> = ({
  sortBy,
  sortOrder,
  onSortChange,
}) => (
  <div className="border-bottom border-off-white py-10px px-15px d-none d-lg-flex gap-20 align-items-center">
    <div className="w-50px"></div>
    <div
      className="w-170px d-flex gap-5 align-items-center cursor-pointer"
      onClick={() => onSortChange("first_name")}
    >
      <div className="fs-13 fw-700 text-black">Referrer Name</div>
      <Sort active={sortBy === "first_name"} direction={sortOrder} />
    </div>
    <div
      className="w-170px d-flex gap-5 align-items-center cursor-pointer"
      onClick={() => onSortChange("referrals_count")}
    >
      <div className=" fs-13 fw-700">Total Referrals</div>
      <Sort active={sortBy === "referrals_count"} direction={sortOrder} />
    </div>
    <div className="w-170px fs-13 fw-700">Referee Details</div>
  </div>
);

export default ReferralTableHeader;
